/**
 * @packageDocumentation
 * @module f1/is
 */

import { t_bounds } from '../types';

export interface IsBounded {
  /**
   * True if number is inside of the bounds, by array index rules (>= lower and < higher)
   *
   * @public
   * @function f1.is.bounded
   * @example
   *
   * ```ts
   * f1.is.bounded([1, 4], 1) => true
   * f1.is.bounded([1, 4], 4) => false
   * f1.is.bounded([1, 4], 0) => false
   * ```
   */
  (bounds: t_bounds, s: number): boolean;
  (bounds: t_bounds): (s: number) => boolean;
}

/**
 * @see IsBounded
 */
export default (bounds: t_bounds, v: number): boolean => {
  return bounds[0] <= v && v <= bounds[1];
};
